import { Neb, Account, HttpRequest } from 'nebulas';
import NebPay from 'nebpay';

/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

class SmartContract {
  constructor(chainId, contractAddress) {
    this.neb = new Neb();
    this.chainId = chainId;
    if (chainId === 1001) {
      this.neb.setRequest(new HttpRequest('https://testnet.nebulas.io'));
    } else {
      this.neb.setRequest(new HttpRequest('https://mainnet.nebulas.io'));
    }
    this.account = Account.NewAccount();
    this.contractAddress = contractAddress;
    this.nebPay = new NebPay();
  }

  async check(fun, args) {
    const from = this.account.getAddressString();
    const accStateResp = await this.neb.api.getAccountState(from);
    const callResp = await this.neb.api.call({
      from,
      to: this.contractAddress,
      value: 0,
      nonce: parseInt(accStateResp.nonce, 10) + 1,
      gasPrice: 1000000,
      gasLimit: 200000,
      contract: { function: fun, args: JSON.stringify(args) },
    });
    return callResp.result;
  }

  getPayInfo(serialNumber) {
    return new Promise((resolve, reject) => {
      const check = async () => {
        try {
          const resp = await this.nebPay.queryPayInfo(serialNumber);
          const respObject = JSON.parse(resp);
          if (respObject.code === 0) {
            resolve(respObject);
          } else {
            setTimeout(() => check(), 10000);
          }
        } catch (ex) {
          reject(ex);
        }
      };
      setTimeout(() => check(), 10000);
    });
  }

  checkTx(txhash) {
    return new Promise((resolve, reject) => {
      const check = async () => {
        try {
          const resp = await this.neb.api.getTransactionReceipt(txhash);
          if (resp.status === 2) {
            setTimeout(() => check(), 2000);
          } else if (resp.status === 1) {
            resolve(resp.execute_result);
          } else {
            reject(resp.execute_result);
          }
        } catch (ex) {
          reject(ex);
        }
      };
      setTimeout(() => check(), 2000);
    });
  }

  async call(value, fun, args) {
    const serialNumber = this.nebPay.call(this.contractAddress, value, fun, JSON.stringify(args), {});
    const payInfo = await this.getPayInfo(serialNumber);
    const [status, result] = await this.checkTx(payInfo.data.hash);
    return [status, result];
  }
}

export default SmartContract;



// WEBPACK FOOTER //
// ./src/lib/contract.js